var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".checked_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "checked_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "checked_svg__st1",
    d: "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 21.79c-5.4 0-9.79-4.39-9.79-9.79S6.6 2.21 12 2.21 21.79 6.6 21.79 12 17.4 21.79 12 21.79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "checked_svg__st1",
    d: "M10.5 16.25c-.26 0-.51-.1-.71-.29l-3.5-3.5a.996.996 0 1 1 1.41-1.41l2.79 2.79 5.79-5.79a.996.996 0 1 1 1.41 1.41l-6.5 6.5c-.18.19-.43.29-.69.29z"
  })));
};
export default SvgChecked;